import React from 'react';
import {view} from '@sail/ui';
import {redactWalletAddress} from 'src/utils/helpers';
import {Text} from 'src/v2/components/common';
import {WalletIcon} from 'src/v2/components/wallet/WalletIcon';
import type {PaymentOption} from 'src/v2/state/types';
import {defineMessages, FormattedMessage} from 'react-intl';
import {COLORS} from 'src/v2/util/color';

const messages = defineMessages({
  exchangeSubtitle: {
    id: 'crypto.payins.v2.wallet_info.exchange_subtitle',
    description: 'Subtitle specifies selected option is an exchange',
    defaultMessage: 'Exchange',
  },
});

interface WalletInfoProps {
  walletOption: PaymentOption;
  address?: string;
}

export const WalletInfo: React.FC<WalletInfoProps> = ({
  walletOption,
  address,
}) => {
  return (
    <view.div
      css={{
        stack: 'x',
        gapX: 'small',
        justifyContent: 'start',
        alignItems: 'center',
      }}
    >
      <WalletIcon
        walletOption={walletOption}
        width="32px"
        height="32px"
        borderRadius="large"
      />
      <view.div css={{stack: 'y'}}>
        <Text type="bodyEmphasized">{walletOption.name}</Text>
        {address ? (
          <Text type="caption" css={{color: COLORS.textSubduedOnLight}}>
            {redactWalletAddress(address)}
          </Text>
        ) : null}
        {walletOption.provider === 'Exchange' ? (
          <Text type="caption" css={{color: COLORS.textSubduedOnLight}}>
            <FormattedMessage {...messages.exchangeSubtitle} />
          </Text>
        ) : null}
      </view.div>
    </view.div>
  );
};
